import {Navigate} from 'react-router-dom';
import useTokenStore from "../../../services/token";
import useUserInfoStore from "../../../services/user_info";
//메인 주소
const HomePage = () => {
    //토큰 확인
    const accessToken = useTokenStore(state => state.accessToken);
    const userInfo = useUserInfoStore(state => state.userInfo);

    //토큰 없을 경우 로그인 페이지로
    if (!accessToken) {
        return <Navigate to="/login" replace/>;
    }
    //토큰 있고 어드민일 시 어드민 화면으로
    if (userInfo?.role === 'ADMIN') {
        return <Navigate to="/admin" replace/>;
    }
    //토큰 있고 클라이언트일 시 클라이언트 화면으로
    if (userInfo?.role === 'CLIENT') {
        return <Navigate to="/client" replace/>;
    }
    //그 외에는 로그인 화면으로
    return <Navigate to="/login" replace/>;
};

export default HomePage;